/* eslint-disable jsx-a11y/anchor-has-content */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {filterUrl, isInternalLink} from "../../helpers/filters";

const GET_COMPONENT = gql`
query paragraphRevisionById($id: String!) {
  paragraphById: paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphMobileComponentImage {
          fieldObjectImgMedia {
            ... on FieldParagraphFieldObjectImgMedia {
              entity {
                ... on MediaImage {
                  fieldMediaImage {
                    width
                    height
                    url
                    alt
                    title
                  }
                }
              }
            }
          }
          fieldLink {
            url {
              path
              routed
            }
            title
          }
        }
      }
    }
  }
}
`;

class MobileComponentImage extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
    };

    static defaultProps = {
        componentIndex: null
    };

    componentDidMount() {
      const hero = document.getElementById('heroImage');
      const header = document.getElementsByClassName('site-header yitmMobile');
      if(header.length) {
        hero.style.top = `${header[0].offsetHeight}px`;
      }
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleScroll);
    }

    componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleScroll);
    }

    handleScroll = () => {
      const hero = document.getElementById('heroImage');
      const header = document.getElementsByClassName('site-header yitmMobile');
      if(header.length) {
          hero.style.top = `${header[0].offsetHeight - window.scrollY > 0 ? header[0].offsetHeight - window.scrollY : 0}px`;
      }
    }

    render() {
        const {id, markComponentLoadedAs} = this.props;

        return (
            <Query asyncMode query={GET_COMPONENT} variables={{ id }}>
                {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) {
                        markComponentLoadedAs(id, true);
                        return <div>{error}</div>;
                    }

                    const field = data.paragraphById;

                    markComponentLoadedAs(id, true);

                    // Require image to Render
                    if (!(field.fieldObjectImgMedia && field.fieldObjectImgMedia.entity && field.fieldObjectImgMedia.entity.fieldMediaImage && field.fieldObjectImgMedia.entity.fieldMediaImage.url)) return null;

                    return (
                        <section className="yitm__section yitm__image">
                            {field.fieldLink && field.fieldLink.url && field.fieldLink.url.path ? (
                                <a target={isInternalLink(field.fieldLink.url.path) ? '_self' : '_blank'}
                                   rel={isInternalLink(field.fieldLink.url.path) ? null : 'noopener noreferrer'}
                                   href={filterUrl(field.fieldLink.url.path)}>
                                    <img src={field.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={field.fieldLink.title || field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>
                                </a>
                            ) : <img src={field.fieldObjectImgMedia.entity.fieldMediaImage.url} alt={field.fieldObjectImgMedia.entity.fieldMediaImage.alt}/>}

                        </section>
                    );
                }}
            </Query>
        )
    }

}


export default MobileComponentImage;



// WEBPACK FOOTER //
// ./frontend/components/YITMMobile/MobileComponentImage.jsx